import { render, staticRenderFns } from "./SecondaryMenu.vue?vue&type=template&id=38489f6c&scoped=true"
import script from "./SecondaryMenu.vue?vue&type=script&lang=ts"
export * from "./SecondaryMenu.vue?vue&type=script&lang=ts"
import style0 from "./SecondaryMenu.vue?vue&type=style&index=0&id=38489f6c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38489f6c",
  null
  
)

export default component.exports